import { render } from "./NcrmCompanySmtpWorkspace.vue?vue&type=template&id=1fab685e&scoped=true"
import script from "./NcrmCompanySmtpWorkspace.vue?vue&type=script&lang=js"
export * from "./NcrmCompanySmtpWorkspace.vue?vue&type=script&lang=js"

import "./NcrmCompanySmtpWorkspace.vue?vue&type=style&index=0&id=1fab685e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fab685e"]])

export default __exports__